import actionTypes from 'app/actions/action-types';

export default (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_WIDGETS_SUCCESS:
      return [...action.items];
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/app/reducers/widgets/items.js